import { styled, Button, Box, Typography } from '@mui/material';
import color from 'src/theme/color';

export const SetupCard = styled(Box)({
    width: '17%',
    background: color.blackLight,
    borderRadius: '8px',
    padding: '30px 40px',
    position: 'relative',
    color: color.white
});

export const ServicesCard = styled(Box)({
    width: '17%',
    background: color.blackLight,
    borderRadius: '8px',
    padding: '30px 40px 60px 40px',
    position: 'relative',
    color: color.white,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
});

export const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: color.yellow,
    color: color.white,
    fontWeight: 500,
    borderRadius: theme.spacing(3),
    textTransform: 'none',
    padding: theme.spacing(1.5),
    '&:hover': {
        color: color.yellow,
        backgroundColor: color.yellowTransparent
    },
    '&.Mui-disabled': {
        backgroundColor: `${color.yellow} !important`,
        color: `${color.white} !important`,
        opacity: 0.6
    }
}));

export const CompanyBox = styled(Box)({
    position: 'absolute',
    top: 80,
    left: 50,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
});

export const TitleBox = styled(Box)({
    marginBottom: '32px',
    marginTop: '30px'
});

export const TitleText = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

export const EmojiSpan = styled('span')({
    marginLeft: '8px'
});

export const ButtonContentBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    height: '100%'
});

export const ButtonTextBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        position: 'relative',
        transition: 'transform 0.3s ease-in-out',
        transform: $isHovered ? 'translateX(-8px)' : 'translateX(0)'
    })
);

export const ButtonIconBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        marginLeft: '8px',
        opacity: $isHovered ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 'calc(50% - 36px)'
    })
);

export const IconBox = styled(Box)({
    marginTop: '16px',
    backgroundColor: color.blackLight2,
    width: '170px',
    height: '170px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: '1px solid transparent',
    transition: 'border-color 0.2s ease',
    '&:hover': {
        borderColor: color.yellowTransparent
    },
    '&.selected': {
        borderColor: color.yellow
    },
    borderRadius: '4px'
});

export const IconBoxContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
});

export const ConnectedLabel = styled(Typography)({
    color: color.grey,
    marginTop: '8px',
    fontWeight: 500
});

export const NextButtonContainer = styled(Box)({
    marginTop: '100px',
    width: '10%',
    display: 'flex',
    justifyContent: 'center'
});

export const NextButton = styled(StyledButton)({
    width: '100%'
});

export const ContentContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
});
